import { EMAIL_OPTIN_SECTION_VIEW, EMAIL_OPTIN_STATUS_CHANGED } from './types';

export const triggerEmailOptInSectionIsViewed = () => ({
  type: EMAIL_OPTIN_SECTION_VIEW,
});

export const triggerEmailOptInChangedGaEvent = (isUserCheckedOptIn) => ({
  type: EMAIL_OPTIN_STATUS_CHANGED,
  isUserCheckedOptIn,
});
